import React from 'react';
import CarrotSlice from './CarrotSlice';
import './LegalInfo.less';

class LegalInfo extends React.Component {
  render () {
    return (
      <section className="section section-legal-info">
        <div className="carrot-slices container container-limit">
          <CarrotSlice scale={.5} />
          <CarrotSlice scale={0.6} type={2}/>
          <CarrotSlice scale={0.4} type={3}/>
          <CarrotSlice scale={0.7} rotate="-90deg" type={2}/>
          <CarrotSlice scale={.4} rotate="30deg" type={3}/>
          <CarrotSlice scale={0.6} rotate="30deg" type={2}/>
          <CarrotSlice scale={0.5} rotate="180deg" type={3}/>
        </div>
        <div className="container container-limit">
          <p>
            corpofood.pl Sp. z o.o.<br/>
            KRS 000123456<br/>
          </p>
        </div>
      </section>
    );
  }
}

export default LegalInfo;



// WEBPACK FOOTER //
// ./src/components/LegalInfo/LegalInfo.js